import { render, staticRenderFns } from "./GetCollectedPaymentsReport.vue?vue&type=template&id=c19d977e&scoped=true&"
import script from "./GetCollectedPaymentsReport.vue?vue&type=script&lang=js&"
export * from "./GetCollectedPaymentsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19d977e",
  null
  
)

export default component.exports